import { c as _c } from "react/compiler-runtime";
import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import learnMoreClick from 'commons/learnMoreClick';
import usePDPTieredPrice from 'data-hooks/usePDPTieredPrice';
import useUserData from 'data-hooks/useUserData';
import useAffirmRefreshHTML from 'hooks/useAffirmRefreshHTML';
import PDPFinancingUI from './PDPFinancingUI';
import usePdpIsModularBYOProduct from '../state/context/usePdpIsModularBYOProduct';
const PDPFinancing = t0 => {
  const $ = _c(11);
  const {
    loading
  } = t0;
  const {
    isTradeUser
  } = useUserData();
  const pdpIsModularBYOProduct = usePdpIsModularBYOProduct();
  const {
    loading: priceLoading,
    priceDetails
  } = usePDPTieredPrice();
  const affirmButtonRef = useRef();
  const showLearnMore = useAffirmRefreshHTML(affirmButtonRef);
  const price = !priceDetails?.hasDiscount ? priceDetails?.priceWithOptionsPrice : priceDetails?.hasTieredDiscount ? priceDetails?.maxTieredDiscountedPrice : priceDetails?.salePriceWithOptionsPrice;
  const numberOfMonths = price <= 1499 ? 12 : 18;
  let t1;
  if ($[0] !== numberOfMonths || $[1] !== price) {
    t1 = Math.round(price / numberOfMonths);
    $[0] = numberOfMonths;
    $[1] = price;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const perMonthAmount = t1;
  const isLoading = loading || priceLoading;
  if (isTradeUser) {
    return null;
  }
  let t2;
  if ($[3] !== isLoading || $[4] !== numberOfMonths || $[5] !== pdpIsModularBYOProduct || $[6] !== perMonthAmount || $[7] !== price || $[8] !== priceLoading || $[9] !== showLearnMore) {
    t2 = priceLoading ? null : <PDPFinancingUI loading={isLoading} affirmButtonRef={affirmButtonRef} numberOfMonths={numberOfMonths} onFinancingClick={() => {
      learnMoreClick(affirmButtonRef);
    }} pdpIsModularBYOProduct={pdpIsModularBYOProduct} perMonthAmount={perMonthAmount} price={price} showLearnMore={showLearnMore} />;
    $[3] = isLoading;
    $[4] = numberOfMonths;
    $[5] = pdpIsModularBYOProduct;
    $[6] = perMonthAmount;
    $[7] = price;
    $[8] = priceLoading;
    $[9] = showLearnMore;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  return t2;
};
PDPFinancing.propTypes = {
  loading: PropTypes.bool
};
export default PDPFinancing;